<template>
  <div class="order-list">
    <h3>任务管理</h3>
    <el-form :inline="true" ref="formTask" class="demo-form-inline" size="mini">
      <el-form-item label="任务编号">
        <el-input
          v-model="filter.taskInfoId"
          placeholder="请输入任务编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="任务标题">
        <el-input
          v-model="filter.title"
          placeholder="请输入任务标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="雇主昵称">
        <el-input
          v-model="filter.nickName"
          placeholder="请输入雇主昵称"
        ></el-input>
      </el-form-item>
      <el-form-item label="雇主联系方式">
        <el-input
          v-model="filter.phoneNumber"
          placeholder="请输入雇主联系方式"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filter.shelvesFlag">
          <el-option
            :label="k"
            :value="v"
            v-for="(k, v) in statusMap"
            :key="v"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务类型">
        <el-select v-model="filter.batchFlag">
          <el-option
            :label="k"
            :value="v"
            v-for="(k, v) in statusTask"
            :key="v"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker
          style="width: 320px"
          v-model="valueTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item style="margin-right: 10px">
        <el-button type="primary" plain @click="add()" size="mini"
          >新增</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="resetQuery()" size="mini"
            >重置</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="shelvesFlag" label="状态" width="80px">
        <template slot-scope="scope">
          {{ scope.row.shelvesFlag === 0 ? "已下架" : "已上架" }}
        </template></el-table-column
      >
      <el-table-column prop="shelvesFlag" label="任务状态" width="80px">
        <template slot-scope="scope">
          <!-- 状态 (1待预付款  2发布中  3停止招募  4结束任务) -->
          {{
            scope.row.status === 1
              ? "待预付款"
              : scope.row.status === 2
              ? "接单中"
              : scope.row.status === 3
              ? "停止招募"
              : scope.row.status === 4
              ? "已关闭"
              : ""
          }}
        </template></el-table-column
      >
      <el-table-column prop="batchFlag" label="任务类型">
        <template slot-scope="scope">
          {{ scope.row.batchFlag === 0 ? "单任务" : "整合任务" }}
        </template>
      </el-table-column>
      <el-table-column prop="taskInfoId" width="240px" label="任务编号" />
      <el-table-column prop="title" width="280px" label="任务标题" />
      <el-table-column show-overflow-tooltip width="200px" label="任务接单区域">
        <template slot-scope="scope">
          <span v-if="scope.row.cities">
            <span
              class="city-left"
              v-for="item in scope.row.cities"
              :key="item.id"
              >{{ item.cityName }}

              <span class="city-name" v-for="k in item.cities" :key="k.id">{{
                k.cityName
              }}</span>
            </span>
          </span>
          <span v-else>不限区域</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="发放量" />
      <el-table-column prop="price" label="单价" />
      <el-table-column prop="fee" label="手续费"></el-table-column>
      <el-table-column prop="orderPrice" label="接单金额"> </el-table-column>
      <el-table-column
        prop="nickName"
        width="160px"
        label="雇主昵称"
      ></el-table-column>
      <el-table-column
        width="140px"
        prop="phoneNumber"
        label="雇主联系方式"
      ></el-table-column>
      <el-table-column
        prop="count"
        width="120px"
        label="已接单"
      ></el-table-column>
      <el-table-column
        prop="completeTime"
        width="140px"
        label="任务完成时长"
      ></el-table-column>
      <!-- <el-table-column label="浏览量" prop="" width="100" /> -->

      <el-table-column prop="releaseTime" width="160px" label="发布时间" />
      <el-table-column
        label="操作"
        width="370"
        header-align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: flex-end">
            <template>
              <el-button
                style="margin-left: 2px"
                v-if="scope.row.shelvesFlag === 0"
                size="mini"
                type="success"
                @click="putAway(scope.row)"
                >上架</el-button
              >
              <el-button
                style="margin-left: 2px; background: #f56c6c"
                v-else
                size="mini"
                type="danger"
                @click="putAway(scope.row)"
                >下架</el-button
              >
            </template>

            <el-button
              style="margin-left: 2px; background: #e6a23c"
              v-if="scope.row.shelvesFlag === 0 && scope.row.batchFlag === 1"
              size="mini"
              type="danger"
              @click="update(scope.row)"
              >修改</el-button
            >
            <el-button
              style="margin-left: 2px; background: #409eff; color: #fff"
              size="mini"
              v-if="scope.row.shelvesFlag != 0 && scope.row.status == 2"
              @click="pushTask(scope.row)"
              >推送</el-button
            >
            <el-button
              v-if="scope.row.batchFlag != 1"
              size="mini"
              type="primary"
              style="margin-left: 2px"
              @click="showPushDialog(scope.row)"
              >手续费</el-button
            >
            <el-button
              style="margin-left: 2px; background: #409eff; color: #fff"
              size="mini"
              @click="goDetail(scope.row)"
              >查看任务</el-button
            >

            <el-button
              style="margin-left: 2px; background: #409eff; color: #fff"
              size="mini"
              @click="goTaskPushLog(scope.row)"
              >推送记录</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      width="40%"
      title="任务手续费"
      :visible.sync="pushDialogShow"
      :close-on-click-modal="false"
      append-to-body
      :before-close="pushDialog"
    >
      <el-form ref="feeForm" :model="expense" :rules="feeRules">
        <el-form-item prop="fee">
          <el-input placeholder="请输入手续费" v-model="expense.fee">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushDialog">取 消</el-button>
        <el-button type="primary" @click="submitFee">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="dialogPayChannel"
      :before-close="close"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :inline="true"
        label-width="120px"
        :rules="addRules"
      >
        <el-form-item label="任务标题" prop="title">
          <el-input
            style="width: 500px"
            v-model.trim="addForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择任务" prop="taskInfoIds">
          <el-select
            style="width: 500px"
            multiple
            v-model="addForm.taskInfoIds"
            @change="onChange"
            value-key="taskInfoId"
          >
            <el-option
              v-for="item in selectedList"
              :key="item.id"
              :label="item.title"
              :value="String(item.taskInfoId)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务金额">
          <el-input
            style="width: 500px"
            disabled
            v-model="addForm.price"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务完成时长" prop="completeTime">
          <el-input
            style="width: 500px"
            v-model="addForm.completeTime"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务发放量">
          <el-input
            disabled
            style="width: 500px"
            v-model="addForm.num"
          ></el-input>
        </el-form-item>
        <el-form-item label="单人接单上限" prop="singleOrderCeiling">
          <el-input
            :disabled="isUp"
            style="width: 500px; margin-right: 10px"
            v-model="addForm.singleOrderCeiling"
            placeholder=""
          >
          </el-input>
          <el-checkbox @change="radioChange" v-model="singleOrderCeiling"
            >不设上限</el-checkbox
          >
          <!-- <div v-if="singleOrderCeiling" class="tips-t">
            值为0，表示不设置单人接单上限
          </div> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button
          :loading="submitLoading"
          type="primary"
          @click="updatePayChannel"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="修改整合任务"
      :visible.sync="dialogPayChange"
      :before-close="close"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :inline="true"
        label-width="120px"
        :rules="changeRules"
      >
        <el-form-item label="任务标题" prop="title">
          <el-input
            style="width: 500px"
            v-model.trim="addForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择任务" prop="taskInfoIds">
          <el-select
            style="width: 500px"
            multiple
            v-model="addForm.taskInfoIds"
            @change="onChange"
            value-key="taskInfoId"
          >
            <el-option
              v-for="item in selectedList"
              :key="item.id"
              :label="item.title"
              :value="String(item.taskInfoId)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务金额">
          <el-input
            style="width: 500px"
            disabled
            v-model="addForm.price"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务完成时长" prop="completeTime">
          <el-input
            style="width: 500px"
            v-model="addForm.completeTime"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务发放量">
          <el-input
            disabled
            style="width: 500px"
            v-model="addForm.num"
          ></el-input>
        </el-form-item>
        <el-form-item label="单人接单上限" prop="singleOrderCeiling">
          <el-input
            :disabled="isUp"
            style="width: 500px; margin-right: 10px"
            v-model="addForm.singleOrderCeiling"
            placeholder=""
          >
          </el-input>
          <el-checkbox @change="radioChange" v-model="singleOrderCeiling"
            >不设上限</el-checkbox
          >
          <!-- <div v-if="singleOrderCeiling" class="tips-t">
            值为0，表示不设置单人接单上限
          </div> -->
        </el-form-item>
        <div class="label">
          <span class="label-text"> 任务接单区域</span>
          <div class="city">
            <span class="city-left" v-for="item in cities" :key="item.id"
              >{{ item.cityName }}

              <span class="city-name" v-for="k in item.cities" :key="k.id">{{
                k.cityName
              }}</span>
            </span>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button
          :loading="submitLoading"
          type="primary"
          @click="updatePayChannel"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="输入用户ID"
      :close-on-click-modal="false"
      :before-close="closePush"
      :visible.sync="pushTasks"
    >
      <el-form>
        <el-form-item>
          <p>
            多个用户id使用“#”分割；确定推送后，给用户发送系统通知（如果已经接单，就不发送）
          </p>

          <el-input
            type="textarea"
            :rows="5"
            placeholder="例如：111#222#333"
            v-model="pushData.userIds"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closePush()">取 消</el-button>
        <el-button type="primary" @click="pushMsg">推 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "../request";
import qs from "qs";
import map from "../../datamap";
import moment from "moment";
import api from "../api";

const { taskInfo, role, per, order, user } = api;

export default {
  name: "user-list",
  data() {
    return {
      visible: false,
      loading: true,
      submitLoading: false,
      list: [],
      total: 0,
      limit: 15,
      pageNum: 1,
      total: 0,
      filter: {
        taskInfoId: "",
        title: "",
        nickName: "",
        phoneNumber: "",
        batchFlag: "",
        shelvesFlag: "",

        releaseCreateTimeStr: "",
        releaseCreateTimeStr: "",
      },
      valueTime: [],
      statusMap: {
        0: "已下架",
        1: "已上架 ",
      },
      statusTask: {
        0: "单任务",
        1: "组合任务",
      },
      pushDialogShow: false,
      expense: {
        fee: "",
      }, // 手续费
      feeId: "", //手续费id
      feeRules: {
        fee: [
          { required: true, message: "请输入手续费", trigger: "blur" },
          { pattern: /^(\d+)((?:\.\d+)?)$/, message: "请输入合法数字" },
        ],
      },
      title: "",
      addForm: {
        singleOrderCeiling: "",
        title: "",
        completeTime: "",
        taskInfoIds: [],
        num: "",
        price: "",
      },

      addRules: {
        singleOrderCeiling: [
          { required: true, message: "请输入单人接单上限", trigger: "blur" },
          {
            pattern: /^(\d+)((?:\d+)?)$/,
            message: "请输入合法数字",
            trigger: "change",
          },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "标题长度最多允许30个字符",
            trigger: "blur",
          },
        ],
        completeTime: [
          { required: true, message: "请输入任务完成时长", trigger: "blur" },
          {
            // pattern: /^(\d+)((?:\d+)?)$/,
            pattern: /^[1-9]\d*$/,
            message: "请输入正确的任务完成时长",
          },
        ],
        taskInfoIds: [
          {
            type: "array",
            required: this.isChange ? false : true,
            message: "请至少选择2个任务",
            trigger: "change",
          },
        ],
      },
      changeRules: {
        singleOrderCeiling: [
          { required: true, message: "请输入单人接单上限", trigger: "blur" },
          {
            pattern: /^(\d+)((?:\d+)?)$/,
            message: "请输入合法数字",
            trigger: "change",
          },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "标题长度最多允许30个字符",
            trigger: "blur",
          },
        ],
        completeTime: [
          { required: true, message: "请输入任务完成时长", trigger: "blur" },
          {
            pattern: /^(\d+)((?:\d+)?)$/,
            message: "请输入正确的任务完成时长",
          },
        ],
        // taskInfoIds: [
        //   {
        //     type: "array",
        //     required: this.isChange ? false : true,
        //     message: "请至少选择2个任务",
        //     trigger: "change",
        //   },
        // ],
      },
      selectedList: [],
      isChange: false,
      dialogPayChange: false,

      pushIng: false,
      dialogPayChannel: false,
      curOrder: null,
      isUp: false,
      singleOrderCeiling: "",
      cities: [],
      pushTasks: false,
      pushIng: false,
      tags: [],
      pushRecords: [],
      pushUserId: "",
      pushData: {
        taskInfoId: "",
        userIds: "",
      },
    };
  },
  components: {},
  computed: {
    nickUserName() {
      return location.search;
    },
    payChannel() {
      return map.payChannel;
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;
      let { taskInfoId, title, nickName, phoneNumber, batchFlag, shelvesFlag } =
        this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        taskInfoId,
        title,
        nickName,
        phoneNumber,
        batchFlag,
        shelvesFlag,
      };

      if (this.valueTime) {
        obj.releaseCreateTimeStr = this.valueTime[0] || null;
        obj.releaseEndTimeStr = this.valueTime[1] || null;
      }

      let res = await taskInfo.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },

    resetQuery() {
      this.valueTime = [];
      this.filter = {};
      this.fetch();
    },
    async saveMargin(data) {
      let obj = {
        taskInfoId: data.taskInfoId,
        margin: data.margin,
      };
      if (obj.margin < 0) {
        this.$message.error("请输入正确的预付金额");
      } else {
        let res = await order.margin(obj);
        if (res.data.code == 200) {
          this.$message.success("保存成功");
        }
      }
    },
    showPushDialog(data) {
      this.pushDialogShow = !this.pushDialogShow;
      this.feeId = data.id;
    },
    submitFee() {
      this.$refs["feeForm"].validate((valid) => {
        if (valid) {
          this.$set(this.expense, "id", this.feeId);
          taskInfo.updateFee(this.expense).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("保存成功");
              this.fetch();
              this.pushDialog();
            }
          });
        } else {
          return false;
        }
      });
    },
    pushDialog() {
      this.pushDialogShow = false;
      this.feeId = "";
      this.expense.fee = "";
    },
    // 上架
    putAway(row) {
      if (row.shelvesFlag === 0) {
        //    未上架
        let shelvesFlag = {
          id: row.id,
          shelvesFlag: 1,
        };
        taskInfo.shelvesTask(shelvesFlag).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.fetch();
          }
        });
      } else {
        let Flag = {
          id: row.id,
          shelvesFlag: 0,
        };
        taskInfo.shelvesTask(Flag).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.fetch();
          }
        });
      }
    },
    goDetail(row) {
      let iframeUrl = `${this.frontUrl}/taskHostingPage/detail?taskInfoId=${row.taskInfoId}`;
      window.location.href = iframeUrl;
    },
    goTaskPushLog(row) {
      console.log(row);
      this.$router.push({
        path: "/taskManage/taskPushLog/index",
        query: { taskInfoId: row.taskInfoId },
      });
    },
    add() {
      this.singleOrderCeiling = "";
      this.isUp = false;
      this.title = "新增整合任务";
      this.dialogPayChannel = true;
      this.isChange = false;
      let obj = {
        pageNum: this.pageNum,
        limit: 9999,
        shelvesFlag: 0,
        batchFlag: 0,
        status: 2,
        checkFlag: 1,
      };

      taskInfo.list(obj).then((res) => {
        if (res.data.code == 200) {
          this.selectedList = res.data.data;
        }
      });
    },
    onChange(value) {
      this.addForm.taskInfoIds = value;
    },
    close() {
      this.$refs["addForm"].resetFields();
      this.addForm = {};
      this.dialogPayChannel = false;
      this.singleOrderCeiling = !this.singleOrderCeiling;
      this.dialogPayChange = false;
    },
    async updatePayChannel() {
      if (this.singleOrderCeiling) {
        this.$set(this.addForm, "singleOrderCeiling", 0);
      }
      if (!this.isChange) {
        this.$refs["addForm"].validate((valid) => {
          if (this.addForm.taskInfoIds.length < 2) {
            return this.$message.error("请至少选择2个任务");
          }
          // this.submitLoading = true;
          if (valid) {
            taskInfo.batchAdd(this.addForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
                this.fetch();
                this.close();
                this.submitLoading = false;
              } else {
                this.submitLoading = false;
              }
            });
          } else {
            return false;
          }
        });
      } else {
        // 编辑不需要校验任务数量,可不选

        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            taskInfo.updateBatch(this.addForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
                this.fetch();
                this.close();
                this.submitLoading = false;
              } else {
                this.submitLoading = false;
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    update(row) {
      let obj = {
        pageNum: this.pageNum,
        limit: 9999,
        shelvesFlag: 0,
        batchFlag: 0,
        status: 2,
        checkFlag: 1,
        infoId: row.taskInfoId,
      };

      taskInfo.list(obj).then((res) => {
        if (res.data.code == 200) {
          this.selectedList = res.data.data;
        }
      });
      let id = row.id;
      taskInfo.taskInfoId({ id }).then((res) => {
        if (res.data.code == 200) {
          this.singleOrderCeiling =
            res.data.data.singleOrderCeiling == 1 ? false : true;
          this.addForm = res.data.data;

          this.addForm.taskInfoIds = res.data.data.taskInfoIds;
        }
      });
      console.log(row, "-------------");
      this.cities = row.cities;

      this.isChange = true;
      this.dialogPayChange = true;
    },
    radioChange(value) {
      if (this.singleOrderCeiling) {
        this.isUp = true;
        this.addForm.singleOrderCeiling = 0;
      } else {
        this.isUp = false;
        this.addForm.singleOrderCeiling = "";
      }
    },
    closePush() {
      this.pushUserId = "";
      this.pushData = {};
      this.pushTasks = false;
    },
    pushTask(row) {
      this.pushData.taskInfoId = row.taskInfoId;
      this.pushTasks = true;
    },
    // 推送任务

    pushMsg() {
      if (this.pushData.userIds.length > 0) {
        this.pushIng = true;
        let obj = this.pushData;
        taskInfo.pushPartyB(obj).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("发送成功");
            this.closePush();
          }
        });
        this.pushIng = false;
      } else {
        this.$message.error("请输入正确的用户ID");
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.fon-tex-coll {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tooltip__popper {
  /* background: #ccc !important; */
  max-width: 400px;
}
</style>
<style scoped>
.tips-t {
  color: #9ca6ae;
}
.city-name {
  color: #9ca6ae;
  font-size: 12px;
  margin-right: 3px;
  cursor: pointer;
}
.city-left {
  margin-right: 2px;
  cursor: pointer;
}
.label {
  display: flex;
}
.label-text {
  margin: 0 10px 0 20px;
  width: 140px;
}
</style>


// WEBPACK FOOTER //
// src/views/taskManage/index.vue